<template>
  <q-tab-pane name="payments">
    <!-- Default Payment Deadline -->
    <div class="row gutter-x-md justify-start">
      <div class="col-md-3 col-12">
        <h6 class="q-mt-md q-mb-sm q-title">{{ $t('payment_deadline') }}</h6>
        <p class="text-faded">{{ $t('payment_deadline_hint') }}</p>
      </div>

      <div class="col-md-9 col-12">
        <!-- Default Payment Deadline -->
        <q-field
          :error="errors.has('defaultPaymentDeadline')"
          :error-label="errors.first('defaultPaymentDeadline')"
        >
          <q-input
            v-model="formData.defaultPaymentDeadline"
            v-validate.disable="'required|numeric|min:0'"
            name="defaultPaymentDeadline"
            :placeholder="$t('payment_deadline')"/>
        </q-field>
      </div>
    </div>

    <!-- Default Quote Deadline -->
    <div class="row gutter-x-md justify-start">
      <div class="col-md-3 col-12">
        <h6 class="q-mt-md q-mb-sm q-title">{{ $t('quote_deadline') }}</h6>
        <p class="text-faded">{{ $t('quote_deadline_hint') }}</p>
      </div>

      <div class="col-md-9 col-12">
        <!-- Default Payment Deadline -->
        <q-field
          :error="errors.has('defaultQuoteDeadline')"
          :error-label="errors.first('defaultQuoteDeadline')"
        >
          <q-input
            v-model="formData.defaultQuoteDeadline"
            v-validate.disable="'required|numeric|min:0'"
            name="defaultQuoteDeadline"
            :placeholder="$t('quote_deadline')"/>
        </q-field>
      </div>
    </div>

    <div class="row justify-end">
      <q-btn type="submit" color="primary" @click="handleSave">{{ $t('save') }}</q-btn>
    </div>
  </q-tab-pane>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import changeCase from 'change-case-object'
  import { createErrorFromResponse } from 'src/utils/error'

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    data () {
      return {
        formData: {
          defaultPaymentDeadline: '',
          defaultQuoteDeadline: ''
        }
      }
    },

    computed: {
      ...mapGetters(['team'])
    },

    methods: {
      ...mapActions(['updateTeam']),

      handleSave () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) {
              return
            }

            this.storeChanges()
          })
      },

      storeChanges () {
        this.updateTeam({
          teamId: this.team.id,
          team: changeCase.snake(this.formData)
        })
          .then(() => {
            this.$q.notify({ message: this.$t('team_settings_save_success'), type: 'positive' })
          })
          .catch(createErrorFromResponse)
      }
    },

    created () {
      this.formData = {
        defaultPaymentDeadline: this.team.settings.default_payment_deadline,
        defaultQuoteDeadline: this.team.settings.default_quote_deadline
      }
    }
  }
</script>
